import Vue from "vue";
import VueI18Next from "@panter/vue-i18next";

Vue.use(VueI18Next);

export default VueI18Next;
